export var GRID_UNIT = 4;
export var SERIF_FONT_FAMILY = "'IBM Plex Serif', freight-text-pro, 'Georgia', 'Times New Roman', serif";
export var SANS_FONT_FAMILY = "'IBM Plex Sans', 'Helvetica Neue', 'Open Sans', sans-serif";
export var MONO_FONT_FAMILY = "'IBM Plex Mono', 'consolas', 'monospace'";
export var CONDENSED_FONT_FAMILY = "'IBM Plex Sans Condensed', 'Arial Narrow', 'sans-serif'";
export var ALL_COLORS = {
  dark: '#000000',
  light: '#FFFFFF',
  blue: '#205AA0',
  grey: '#A1A1A1',
  orange: '#F05A29',
  yellow: '#FFCA04',
  yellowOrange: '#FFA000',
  green: '#009900',
  lime: '#79AF02',
  primary: '#FCB017',
  primaryDarker: '#F7941C',
  primaryLight: '#FEE7B9',
  primaryLighter: '#FFCB03',
  primaryBright: '#FCB017',
  primaryVeryLight: '#FFF1BD',
  secondary: '#333333',
  submit: 'yellowgreen',
  error: '#FF0000',
  text: '#555759',
  textTag: '#777777',
  textFade: '#8E8E8E',
  textMid: '#969696',
  textSidebar: '#8B8B8B',
  textSubtle: '#ABABAB',
  textVerySubtle: '#BFC0BF',
  textInverted: '#FFF',
  textInvertedSubtle: '#AAA',
  textDisabled: '#DDD',
  textTitle: '#0D0D0D',
  bold: '#0D0D0D',
  line: '#BFC0BF',
  lineMid: '#D2D2D2',
  lineFilter: '#E7E7E7',
  lineDark: '#999',
  lineSidebar: '#E1E1E1',
  lineSidebarSubtle: '#E6E6E6',
  lineSemiSubtle: '#DADADA',
  lineSubtle: '#EEEEEE',
  appChrome: '#F5F5F5',
  link: '#205AA0',
  linkHover: '#E1A449',
  linkInverted: '#FFFFFF',
  linkInvertedHover: '#E1A449',
  navigationActive: '#FCB017',
  sdg: {
    affordableCleanEnergy: '#FBC410',
    cleanerWaterSanitation: '#29BFE6',
    climateAction: '#417F46',
    decentWorkAndEconomicGrowth: '#A31D44',
    genderEquality: '#EE402D',
    goodHealthAndWellbeing: '#4CA146',
    industryInnovationAndInfrastructure: '#F16A2F',
    lifeBelowWater: '#1E97D4',
    lifeOnLand: '#58BA47',
    noPoverty: '#E5233D',
    partnerships: '#15496B',
    peaceJusticeAndStrongInstitutions: '#15699F',
    qualityEducation: '#C7212F',
    reducedInequalities: '#E11484',
    responsibleConsumptionAndProduction: '#BF8D2C',
    sustainableCitiesAndCommunities: '#F89D2A',
    zeroHunger: '#DDA739'
  },
  progress: {
    none: '#D2D2D2'
  }
};
export var ALL_BG_COLORS = {
  page: '#DEDEDE',
  pageContainer: '#FFF',
  contentHighlight: '#F9F9F9',
  light: '#FAFAFA',
  dark: '#000000',
  mid: '#CBCBCB',
  appChrome: '#F5F5F5',
  textBubble: '#969696',
  formHeader: '#F5F5F5',
  tableHeader: '#F5F5F5',
  tableLightHeader: '#FCFCFC',
  formPanel: '#FCFCFC',
  dialogBody: '#FFFBF3',
  footer: '#333333'
};
export var DEFAULT_THEME = {
  background: ALL_BG_COLORS,
  color: ALL_COLORS,
  grid: {
    unit: GRID_UNIT,

    /* bracket sizes in multiples of grid unit */
    bracket: {
      normal: {
        base: 4,
        landscape: 4,
        tablet: 10,
        desktop: 16,
        desktopLarge: 20
      }
    },
    icon: {
      normal: {
        base: 8,
        landscape: 8,
        tablet: 10,
        desktop: 16,
        desktopLarge: 20
      }
    }
  },
  lineHeight: {
    copy: 1.6,
    heading: 1.1,
    copyTight: 1.45,
    sans: 1.35,
    serif: 1.35
  },
  font: {
    size: {
      tiny: {
        base: 12,
        landscape: 12,
        tablet: 13,
        desktop: 14,
        desktopLarge: 14
      },
      verySmall: {
        base: 12,
        landscape: 13,
        tablet: 14,
        desktop: 15,
        desktopLarge: 15
      },
      small: {
        base: 14,
        landscape: 14,
        tablet: 15,
        desktop: 16,
        desktopLarge: 16
      },
      slight: {
        base: 15,
        landscape: 15,
        tablet: 16,
        desktop: 18,
        desktopLarge: 20
      },
      normal: {
        base: 16,
        landscape: 16,
        tablet: 18,
        desktop: 21,
        desktopLarge: 21
      },
      medium: {
        base: 18,
        landscape: 22,
        tablet: 24,
        desktop: 26,
        desktopLarge: 28
      },
      title: {
        base: 18,
        landscape: 22,
        tablet: 24,
        desktop: 28,
        desktopLarge: 28
      },
      large: {
        base: 22,
        landscape: 24,
        tablet: 36,
        desktop: 42,
        desktopLarge: 42
      },
      huge: {
        base: 36,
        landscape: 36,
        tablet: 64,
        desktop: 84,
        desktopLarge: 96
      }
    },
    family: {
      serif: SERIF_FONT_FAMILY,
      sans: SANS_FONT_FAMILY,
      mono: MONO_FONT_FAMILY,
      heading: SANS_FONT_FAMILY,
      copy: SANS_FONT_FAMILY,
      condensed: CONDENSED_FONT_FAMILY
    }
  },
  dimension: {
    max: {
      pageWidth: 1540,
      contentWidth: 1440,
      contentWidthCorrected: 1185
    },
    min: {
      contentWidth: 320
    }
  }
};
DEFAULT_THEME.color.accentLight = DEFAULT_THEME.color.primaryLight;
DEFAULT_THEME.color.accentDark = DEFAULT_THEME.color.primaryDarker;
export default DEFAULT_THEME;